module.exports = __webpack_public_path__ + "img/banner02.494d17a9.jpg";